import React, { useEffect, useState } from "react";
import { Accordion, Form, Button } from "react-bootstrap";
import ImageInput from "./ImageInput";
import SendTo from "./SendTo";

const AcordionFormConfig = ({
    handleSubmit,
    submitFormConfig,
    errors,
    register,
    companies,
    edit,
    form,
    setEditFormConfig,
    mails,
    setMails,
}) => {
    const [fields, setFields] = useState([]);

    return (
        <Accordion.Item eventKey={edit && "0"}>
            <Accordion.Header className="accordion-name">
                Form Config
            </Accordion.Header>
            <Accordion.Body>
                <form onSubmit={handleSubmit(submitFormConfig)}>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Label>Company</Form.Label>
                        <Form.Select
                            size="sm"
                            name="company_id"
                            defaultValue={
                                edit
                                    ? form.company_id && form.company_id
                                    : "Select company"
                            }
                            className={`input-border form-control  ${
                                errors.company_id ? "is-invalid" : ""
                            }`}
                            {...register("company_id", {
                                required: "Obligatory field",
                            })}
                        >
                            <option
                                disabled
                                value={
                                    edit
                                        ? form.company_id && form.company_id
                                        : "Select company"
                                }
                            >
                                {edit
                                    ? form.company && form.company.name
                                    : "Select company"}
                            </option>
                            {companies &&
                                companies.map((item) => {
                                    return (
                                        <option value={item.id} key={item.id}>
                                            {item.name}
                                        </option>
                                    );
                                })}
                        </Form.Select>
                        {errors.company_id && (
                            <div className="invalid-feedback">
                                {errors.company_id.message}
                            </div>
                        )}
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Label>Form Name</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            name="name "
                            defaultValue={edit ? form.name : ""}
                            className={`input-border form-control  ${
                                errors.send_to ? "is-invalid" : ""
                            }`}
                            {...register("name", {
                                required: "Obligatory field",
                            })}
                        />
                        {errors.name && (
                            <div className="invalid-feedback">
                                {errors.name.message}
                            </div>
                        )}
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Label>Slug</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            name="slug"
                            defaultValue={edit ? form.slug : ""}
                            className={`input-border form-control  ${
                                errors.slug ? "is-invalid" : ""
                            }`}
                            {...register("slug", {
                                required: "Obligatory field",
                            })}
                        />
                        {errors.slug && (
                            <div className="invalid-feedback">
                                {errors.name.slug}
                            </div>
                        )}
                    </Form.Group>
                    <SendTo
                        fields={fields}
                        setFields={setFields}
                        mails={mails}
                        setMails={setMails}
                        edit={edit}
                        form={form}
                    />

                    <ImageInput
                        name="autorespuesta"
                        label="Auto Respuesta"
                        folder="email-respuestas"
                        register={register}
                        imagen={
                            typeof form != "undefined"
                                ? form.autorespuesta
                                : null
                        }
                    ></ImageInput>

                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea2"
                    >
                        <Form.Label>Link Autorespuesta</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            name="link_autorespuesta"
                            defaultValue={edit ? form.link_autorespuesta : ""}
                            className={`input-border form-control  ${
                                errors.link_autorespuesta ? "is-invalid" : ""
                            }`}
                            {...register("link_autorespuesta")}
                        />
                        {errors.link_autorespuesta && (
                            <div className="invalid-feedback">
                                {errors.link_autorespuesta.message}
                            </div>
                        )}
                    </Form.Group>

                    <ImageInput
                        name="retargeting"
                        label="Re-Targeting"
                        folder="email-retargeting"
                        register={register}
                        imagen={
                            typeof form != "undefined" ? form.retargeting : null
                        }
                    ></ImageInput>

                    <Form.Group className="mb-3" controlId="retargeting-time">
                        <Form.Label>Retargeting Retraso</Form.Label>
                        <Form.Select
                            size="sm"
                            name="retargeting_sleep"
                            defaultValue={
                                edit
                                    ? form.retargeting_sleep &&
                                      form.retargeting_sleep
                                    : ""
                            }
                            className={`input-border form-control  ${
                                errors.retargeting_sleep ? "is-invalid" : ""
                            }`}
                            {...register("retargeting_sleep")}
                        >
                            <option disabled value="">
                                Selecciona retraso
                            </option>
                            <option value="+1 day">1 Día</option>
                            <option value="+3 day">3 Días</option>
                            <option value="+5 day">5 Días</option>
                            <option value="+7 day">7 Días</option>
                            <option value="+14 day">14 Días</option>
                            <option value="+1 month">1 Mes</option>
                        </Form.Select>
                        {errors.retargeting_sleep && (
                            <div className="invalid-feedback">
                                {errors.retargeting_sleep.message}
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-grid gap-2 mt-3">
                        {edit ? (
                            <Button
                                type="submit"
                                variant="success"
                                size="sm"
                                onClick={() => {
                                    setEditFormConfig(true);
                                }}
                            >
                                Editar
                            </Button>
                        ) : (
                            <Button type="submit" variant="primary" size="sm">
                                Agregar
                            </Button>
                        )}
                    </div>
                </form>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default AcordionFormConfig;
